// ===============================
// File B (Obfuscated RRP Script) — FULL FIXED VERSION v3
// Added null checks for missing categories/options
// ===============================

(function(_0x3851c9,_0x3896fc){const _0x3791f0=a0_0x5e69,_0x4433d5=_0x3851c9();while(!![]){try{const _0xd93a8d=parseInt(_0x3791f0(0x103))/0x1*(parseInt(_0x3791f0(0x100))/0x2)+-parseInt(_0x3791f0(0x124))/0x3+parseInt(_0x3791f0(0x115))/0x4+-parseInt(_0x3791f0(0xf4))/0x5*(-parseInt(_0x3791f0(0xf5))/0x6)+parseInt(_0x3791f0(0x10f))/0x7*(-parseInt(_0x3791f0(0x118))/0x8)+parseInt(_0x3791f0(0xfc))/0x9+-parseInt(_0x3791f0(0xfa))/0xa*(parseInt(_0x3791f0(0x111))/0xb);if(_0xd93a8d===_0x3896fc)break;else _0x4433d5['push'](_0x4433d5['shift']());}catch(_0xa907ed){_0x4433d5['push'](_0x4433d5['shift']());}}}(a0_0x10e1,0xdb919),((()=>{const _0x302fb8=a0_0x5e69,_0x143b31=()=>{const _0x30c2ba=a0_0x5e69,_0x55a3b0={},_0x3f152e={},_0x2c4ab4=CPB[_0x30c2ba(0x10b)]()[_0x30c2ba(0xf0)]()[_0x30c2ba(0x11e)],_0x28b9ac=(_0x2c4ab4[_0x30c2ba(0xf6)]['price'],+_0x2c4ab4[_0x30c2ba(0x11a)]['find'](_0x1b476f=>_0x30c2ba(0x101)===_0x1b476f[_0x30c2ba(0xfd)])?.[_0x30c2ba(0x114)]);let _0x4879d9=!0x0;if(!_0x28b9ac)return console[_0x30c2ba(0x107)]('Product\x20has\x20no\x20\x22rrp-base-price\x22\x20metafield');const _0x4f2718=((()=>{const _0x4558d9=_0x30c2ba,_0x5d4948={},_0x2f9e12=CPB[_0x4558d9(0x10b)]()[_0x4558d9(0xf0)]()[_0x4558d9(0x10a)][_0x4558d9(0xee)][_0x4558d9(0xfb)];for(const _0x4f0378 in _0x2f9e12)for(const _0x5bfd0f in _0x2f9e12[_0x4f0378])_0x2f9e12[_0x4f0378][_0x5bfd0f][_0x4558d9(0x116)](_0x42b6a7=>{const _0x32db67=_0x4558d9;const panel=_0x2c4ab4[_0x32db67(0xf1)]['find'](_0x5c9f9a=>_0x5c9f9a['id']==_0x4f0378);if(!panel||!panel['categories'])return;const category=panel['categories'][_0x32db67(0xf7)](_0x4a0815=>_0x4a0815['id']==_0x5bfd0f);if(!category||!category[_0x32db67(0xfe)])return;const option=category[_0x32db67(0xfe)][_0x32db67(0xf7)](_0x44e001=>_0x44e001['id']===_0x42b6a7);if(option&&option['price'])_0x5d4948[_0x42b6a7]=+option['price'];});return _0x5d4948;})());_0x2c4ab4[_0x30c2ba(0xf1)][_0x30c2ba(0x116)](_0x11574d=>{const _0x308b79=_0x30c2ba;if(!_0x11574d[_0x308b79(0x120)])return;_0x11574d[_0x308b79(0x120)][_0x308b79(0x116)](_0x38f23b=>{const _0x3fdb12=_0x308b79;if(!_0x38f23b[_0x3fdb12(0xfe)])return;_0x38f23b[_0x3fdb12(0xfe)][_0x3fdb12(0x116)](_0x2b8d29=>{const _0x5510ce=_0x3fdb12;if(!_0x2b8d29)return;_0x2b8d29[_0x5510ce(0x11a)]&&_0x2b8d29[_0x5510ce(0x11a)][_0x5510ce(0xf7)](_0x2bb05f=>_0x5510ce(0x106)===_0x2bb05f[_0x5510ce(0xfd)])?_0x55a3b0[_0x2b8d29['id']]=+_0x2b8d29[_0x5510ce(0x11a)][_0x5510ce(0xf7)](_0x4b3f1b=>_0x5510ce(0x106)===_0x4b3f1b[_0x5510ce(0xfd)])[_0x5510ce(0x114)]:(_0x55a3b0[_0x2b8d29['id']]=null,_0x2b8d29[_0x5510ce(0x105)]&&_0x2b8d29[_0x5510ce(0x105)][_0x5510ce(0x11f)]?_0x3f152e[_0x2b8d29['id']]=_0x2b8d29[_0x5510ce(0x105)][_0x5510ce(0x11f)][_0x5510ce(0xed)]:null);});});}),Object[_0x30c2ba(0x108)](_0x3f152e)['length']>0x0&&console[_0x30c2ba(0x123)](_0x30c2ba(0x102),_0x3f152e),console[_0x30c2ba(0x123)](_0x30c2ba(0x11d),_0x55a3b0);const _0x2a75d9={'elem':null,'createElem'(){const _0x424b94=_0x30c2ba,_0x3cbd14=document['createElement'](_0x424b94(0x122));_0x3cbd14[_0x424b94(0x11c)][_0x424b94(0x112)](_0x424b94(0xf9)),_0x3cbd14[_0x424b94(0x117)]=_0x424b94(0x10d),this['elem']=_0x3cbd14;},'formatNumber'(num){
    num = Math.round(num);
    return num >= 1000 ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : num.toString();
},'updateTextContent'(_0x3d79f6,_0x3d79f7){
    const _0x1a0e88=_0x30c2ba;
    
    // Clear previous content first
    this[_0x1a0e88(0xf3)].innerHTML = '';
    
    // Only show RRP and savings if savings amount is greater than 0
    if (_0x3d79f7 > 0) {
        // Set container styles for horizontal alignment on same line
        Object.assign(this[_0x1a0e88(0xf3)].style, {
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          flexWrap: 'nowrap',
          whiteSpace: 'nowrap'
        });

        // Create RRP span
        const rrpSpan = document.createElement('span');
        Object.assign(rrpSpan.style, {
          textDecoration: 'line-through',
          color: '#999',
          fontWeight: '500',
          display: 'inline',
          lineHeight: '1',
          whiteSpace: 'nowrap'
        });
        rrpSpan.textContent = `$${this.formatNumber(_0x3d79f6)}`;

        // Create styled savings span with SAVE in all caps and bold
        const savingsSpan = document.createElement('span');
        savingsSpan.textContent = ` SAVE $${this.formatNumber(_0x3d79f7)}`;

        Object.assign(savingsSpan.style, {
          display: 'inline',
          color: '#22c55e',
          fontWeight: '700',
          fontSize: '20px',
          whiteSpace: 'nowrap',
          lineHeight: '1'
        });

        // Append new spans
        this[_0x1a0e88(0xf3)].appendChild(rrpSpan);
        this[_0x1a0e88(0xf3)].appendChild(savingsSpan);
    }
}};_0x2a75d9[_0x30c2ba(0xef)]();

/* ===========================
   FIX START: MutationObserver approach
   Watches for container to appear AND re-mounts if removed
   =========================== */
(function mountRrpWidgetSafely(){
  const selector = '.cpb-custom-product-price-container';
  let observer = null;

  const attemptMount = () => {
    const parent = document.querySelector(selector);
    if (!parent) {
      console.log('RRP: Container not found yet');
      return false;
    }

    // Check if already mounted
    if (parent.querySelector('.cpb-custom-rrp')) {
      console.log('RRP: Already mounted');
      return true;
    }

    // Mount it
    parent.append(_0x2a75d9[_0x30c2ba(0xf3)]);
    console.log('RRP: Successfully mounted');
    
    // Trigger update
    document.body.dispatchEvent(new Event('CPB_ON_OPTIONS_UPDATE'));
    return true;
  };

  // Watch for the container to appear in the DOM
  observer = new MutationObserver(() => {
    attemptMount();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Try immediately
  setTimeout(attemptMount, 0);
  
  // Also try when File A fires its event
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    console.log('RRP: Received CPB_ON_PRODUCT_MOUNTED');
    setTimeout(attemptMount, 150);
    setTimeout(attemptMount, 500);
  });

  // Final fallback attempts
  setTimeout(attemptMount, 1000);
  setTimeout(attemptMount, 2000);
  setTimeout(attemptMount, 3000);
})();
/* ===========================
   FIX END
   =========================== */

document[_0x30c2ba(0x110)][_0x30c2ba(0x119)](_0x30c2ba(0x125),()=>{const _0x5a87c1=_0x30c2ba,_0x1cef33=((()=>{const _0x3b0e65=a0_0x5e69;let _0x32eb53=0x0;const _0x1a53b6=CPB[_0x3b0e65(0x10b)]()[_0x3b0e65(0xf0)]()[_0x3b0e65(0x11e)][_0x3b0e65(0xec)],_0x4d3c21=CPB[_0x3b0e65(0x10b)]()[_0x3b0e65(0xf0)]()[_0x3b0e65(0x11e)]['layers'],_0x3d8f42={};for(let _0x30a411 in _0x1a53b6){for(let _0x458988 in _0x1a53b6[_0x30a411]){const _0x2e8d12=_0x1a53b6[_0x30a411][_0x458988];if(_0x2e8d12['value']){const _0x5e9d3e=_0x2e8d12['option'];if(_0x5e9d3e){_0x3d8f42[_0x5e9d3e]=true;}}Object['keys'](_0x1a53b6[_0x30a411][_0x458988]['options']||{})[_0x3b0e65(0x116)](_0x1d354a=>{_0x3d8f42[_0x1d354a]=true;});}}if(_0x4d3c21){_0x4d3c21[_0x3b0e65(0x116)](_0x3a5e12=>{if(_0x3a5e12['option']&&_0x3a5e12['panel']!=='base'){_0x3d8f42[_0x3a5e12['option']]=true;}});}for(let _0x26f40c in _0x55a3b0){if(_0x3d8f42[_0x26f40c]&&_0x55a3b0[_0x26f40c]!=null){_0x32eb53+=_0x55a3b0[_0x26f40c];}}return _0x32eb53+_0x28b9ac;})()),_0x4a30b5=CPB[_0x5a87c1(0x10b)]()[_0x5a87c1(0xf0)]()[_0x5a87c1(0x11e)][_0x5a87c1(0x104)],_0x4a30b6=_0x1cef33-_0x4a30b5;_0x2a75d9[_0x5a87c1(0x11b)](_0x1cef33,_0x4a30b6);});};document['body'][_0x302fb8(0x119)](_0x302fb8(0xeb),()=>{_0x143b31();});})()));

function a0_0x5e69(_0x4f703d,_0x11e479){const _0x10e1b9=a0_0x10e1();return a0_0x5e69=function(_0x5e69d5,_0x3b4871){_0x5e69d5=_0x5e69d5-0xeb;let _0x35910e=_0x10e1b9[_0x5e69d5];return _0x35910e;},a0_0x5e69(_0x4f703d,_0x11e479);}

function a0_0x10e1(){const _0x4f537c=['body','11LgpBLY','add','textContent','value','6052060qSWTcx','forEach','style','325688SrIPMI','addEventListener','metafields','updateTextContent','classList','Detected\x20RRP\x20prices\x20{optionId:\x20RRP_price}','Product','data','categories','assign','span','log','2947350GZEKUH','CPB_ON_OPTIONS_UPDATE','length','CPB_ON_PRODUCT_MOUNTED','userChanges','label','settings','createElem','getState','panels','layer','elem','137935jIWHbJ','30hjPGyf','base','find','.cpb-custom-product-price-container','cpb-custom-rrp','3962810LsDthq','defaultOptions','5850513EVIAFv','key','options','\x20Save:\x20$','3342CHLBZu','rrp-base-price','Options\x20without\x20\x22rrp-choice-price\x22\x20metafield','571nSkhqL','price','option','rrp-choice-price','error','keys','querySelector','App','getStore','append','margin-inline-start:\x20.5rem;font-weight:\x20700;font-size:\x2020px;color:\x20red;','reduce','168klsytW'];a0_0x10e1=function(){return _0x4f537c;};return a0_0x10e1();}